<div class="about-us" data-aos="zoom-in" data-aos-easing="ease-out-cubic">
  <!-- <div class="items">
    <div class="top">
      <div class="item-element" *ngFor="let info of information">
        <img src="{{ info.icon }}" />
        <h2>{{ info.title }}</h2>
        <div class="underline-text"></div>
      </div>
    </div>

    <div class="down">
      <div class="lower-1">
        <div class="lower-part-title">
          <h2>Become POS agent</h2>
        </div>
        <div class="lower-part-sub-title">
          <h3>Get HuiosPay POS device from us.</h3>
        </div>
        <div class="lower-part-button">
          <div class="action-button-holder">
            <button class="action-button">
              <a
                href="become-agent"
                style="text-decoration: none; color: inherit"
                >Apply</a
              >
            </button>
          </div>
        </div>
      </div>
      <div class="lower-2">
        <div class="lower-part-title">
          <h2>Become POS agent</h2>
        </div>
        <div class="lower-part-sub-title">
          <h3>Get HuiosPay POS device from us.</h3>
        </div>
        <div class="lower-part-button">
          <div class="action-button-holder">
            <button class="action-button">
              <a
                href="become-agent"
                style="text-decoration: none; color: inherit"
                >Apply</a
              >
            </button>
          </div>
        </div>
      </div>
      <div class="lower-3">
        <div class="lower-part-title">
          <h2>Become POS agent</h2>
        </div>
        <div class="lower-part-sub-title">
          <h3>Get HuiosPay POS device from us.</h3>
        </div>
        <div class="lower-part-button">
          <div class="action-button-holder">
            <button class="action-button">
              <a
                href="become-agent"
                style="text-decoration: none; color: inherit"
                >Apply</a
              >
            </button>
          </div>
        </div>
      </div>
    </div>
  </div> -->

  <div class="about-us-divider">
    <ul class="about-us-list">
      <li *ngFor="let info of information">
        <div
          (mouseover)="showAboutSectionText(info.id, $event)"
          (click)="navigate(info.id)"
        >
          <img
            src="{{ info.icon }}"
            alt="services"
            height="200px"
            width="200px"
            title="{{ info.urlText }}"
          />
          <h2 title="{{ info.urlText }}">{{ info.title }}</h2>
          <div class="underline-text"></div>
        </div>
      </li>
    </ul>
  </div>

  <!-- <div class="lower-part">
    <div class="lower-part-1" *ngIf="isLowerPart1">
      <div class="lower-part-title">
        <h2>Become POS agent</h2>
      </div>
      <div class="lower-part-sub-title">
        <h3>Get HuiosPay POS device from us.</h3>
      </div>
      <div class="lower-part-button">
        <div class="action-button-holder">
          <button class="action-button">
            <a href="become-agent" style="text-decoration: none; color: inherit"
              >Apply</a
            >
          </button>
        </div>
      </div>
    </div>
    <div class="lower-part-2" *ngIf="isLowerPart2">
      <div class="lower-part-title">
        <h2>Become POS merchant</h2>
      </div>
      <div class="lower-part-sub-title">
        <h3>Register and have multiple POS devices for various location</h3>
      </div>
      <div class="lower-part-button">
        <div class="action-button-holder">
          <button class="action-button">
            <a
              href="become-merchant"
              style="text-decoration: none; color: inherit"
              >Apply</a
            >
          </button>
        </div>
      </div>
    </div>
    <div class="lower-part-3" *ngIf="isLowerPart3">
      <div class="lower-part-title">
        <h2>Payment Gateway</h2>
      </div>
      <div class="lower-part-sub-title">
        <h3>Apply for our Payment Gateway integration</h3>
      </div>
      <div class="lower-part-button">
        <div class="action-button-holder">
          <button class="action-button">
            <a
              href="https://dashboard.huiospay.com/registration/67a09908-6119-11ee-bfbe-7a0e4acd3f16"
              style="text-decoration: none; color: inherit"
              >Apply</a
            >
          </button>
        </div>
      </div>
    </div>
  </div> -->
</div>
